// @flow
import * as React from "react";

type Props = {
  title: string,
};

function PageTitle({ title }: Props): React.Node {
  React.useEffect(() => {
    document.title = `${title} | Vortex Advertising`;

    return () => {
      document.title = "Vortex Advertising";
    };
  }, [title]);

  return null;
}

export default PageTitle;
